import React from 'react';

type TableTBodyWrapperProps = {
  style?: React.CSSProperties;
  children: React.ReactNode;
};
export function TableTBodyWrapper({ style, children }: TableTBodyWrapperProps) {
  return (
    <table align="center" width="100%" style={style} role="presentation" cellSpacing="0" cellPadding="0" border={0}>
      <tbody>{children}</tbody>
    </table>
  );
}
